module.exports = __webpack_public_path__ + "img/12 - Condominio_das_Americas_LazerPiscina.6f49c503.jpg";